module.exports = __webpack_public_path__ + "img/address.e82bb7d1.jpg";